import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=e3ed29d6"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports